/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPrinterIcon16Solid = forwardRef('TechPrinterIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 6V3a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3h1a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1Zm1.5-3a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v3h-7V3Zm8.999 6.248a.749.749 0 1 0 0-1.498.749.749 0 0 0 0 1.498ZM5 10.75a.5.5 0 0 0-.5.5V14a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-2.75a.5.5 0 0 0-.5-.5H5Z" })));
});
